var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"canvasRef",staticClass:"canvasBox11",attrs:{"id":"bgCanvas"}})
}
var staticRenderFns = []

export { render, staticRenderFns }